document.addEventListener('DOMContentLoaded', () => {
  const menu = document.querySelector('[data-menu]');
  document.querySelector('[data-menu-toggle]')?.addEventListener('click', () => menu?.classList.toggle('mobile-menu'));
  const layer = document.querySelector('[data-cart-layer]');
  const openCart = async () => {
    if (!layer) return;
    const cart = await fetch('/cart.js').then(r => r.json());
    renderCart(cart);
    layer.classList.add('is-open'); layer.setAttribute('aria-hidden', 'false');
  };
  document.querySelectorAll('[data-cart-open]').forEach(el => el.addEventListener('click', openCart));
  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', () => { layer?.classList.remove('is-open'); layer?.setAttribute('aria-hidden', 'true'); }));
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: Shopify.currency.active }).format(cents / 100);
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    const content = document.querySelector('[data-cart-content]'); if (!content) return;
    if (!cart.items.length) { content.innerHTML = '<div class="cart-empty"><h3>Your bag is taking a nap.</h3><p>Add a cozy little something for your companion.</p></div>'; return; }
    content.innerHTML = `<div class="drawer-items">${cart.items.map(item => `<div class="drawer-item"><img src="${item.image}" alt=""><div><h3>${item.product_title}</h3><p>${item.variant_title || ''}</p><strong>${money(item.final_line_price)}</strong></div></div>`).join('')}</div><div class="drawer-total"><span>Subtotal</span><strong>${money(cart.total_price)}</strong></div><div class="drawer-actions"><a class="button button-dark" href="/checkout">Secure checkout</a><a class="text-link" href="/cart">View bag</a></div>`;
  }
  document.querySelectorAll('[data-image-src]').forEach(button => button.addEventListener('click', () => {
    const main = document.querySelector('[data-main-image]'); if (main) main.src = button.dataset.imageSrc;
    document.querySelectorAll('[data-image-src]').forEach(el => el.classList.remove('active')); button.classList.add('active');
  }));
  const productRoot = document.querySelector('[data-product-root]');
  if (productRoot) {
    const variants = JSON.parse(document.querySelector('[data-product-json]').textContent);
    const slides = [...document.querySelectorAll('[data-slide]')];
    const dots = [...document.querySelectorAll('[data-gallery-dot]')];
    let activeSlide = Math.max(0, slides.findIndex(slide => slide.classList.contains('active')));
    const showSlide = index => {
      if (!slides.length) return;
      activeSlide = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('active', i === activeSlide));
      dots.forEach((dot, i) => dot.classList.toggle('active', i === activeSlide));
    };
    document.querySelector('[data-gallery-prev]')?.addEventListener('click', () => showSlide(activeSlide - 1));
    document.querySelector('[data-gallery-next]')?.addEventListener('click', () => showSlide(activeSlide + 1));
    dots.forEach(dot => dot.addEventListener('click', () => showSlide(Number(dot.dataset.galleryDot))));
    const selected = {};
    document.querySelectorAll('[data-option-position]').forEach(group => {
      const pos = Number(group.dataset.optionPosition); const active = group.querySelector('.active'); selected[pos] = active?.dataset.optionValue;
      group.querySelectorAll('[data-option-value]').forEach(button => button.addEventListener('click', () => {
        selected[pos] = button.dataset.optionValue; group.querySelectorAll('button').forEach(el => el.classList.remove('active')); button.classList.add('active');
        const optionLabel = document.querySelector(`[data-option-label="${pos}"]`);
        if (optionLabel) optionLabel.textContent = button.dataset.optionValue;
        const values = Object.keys(selected).sort().map(key => selected[key]); const variant = variants.find(v => values.every((value, i) => v.options[i] === value));
        if (variant) {
          document.querySelector('[data-variant-id]').value = variant.id;
          document.querySelector('[data-product-price]').textContent = money(variant.price);
          const comparePrice = document.querySelector('[data-compare-price]');
          const compareAtPrice = Number(variant.compare_at_price || 0);
          if (comparePrice) {
            comparePrice.textContent = compareAtPrice ? money(compareAtPrice) : '';
            comparePrice.hidden = compareAtPrice <= Number(variant.price);
          }
          const variantImage = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
          const mainImage = document.querySelector('[data-main-image]');
          if (variantImage && mainImage) {
            mainImage.src = variantImage;
            const normalized = variantImage.split('?')[0];
            document.querySelectorAll('[data-image-src]').forEach(thumb => {
              thumb.classList.toggle('active', (thumb.dataset.imageSrc || '').split('?')[0] === normalized);
            });
          }
          const variantImageId = String(variant.featured_image?.id || variant.featured_media?.id || '');
          const matchingSlide = slides.findIndex(slide => slide.dataset.imageId === variantImageId);
          if (matchingSlide >= 0) showSlide(matchingSlide);
        }
      }));
    });
    const qty = document.querySelector('[data-quantity]'); document.querySelector('[data-qty-minus]')?.addEventListener('click', () => qty.value = Math.max(1, Number(qty.value) - 1)); document.querySelector('[data-qty-plus]')?.addEventListener('click', () => qty.value = Number(qty.value) + 1);
    document.querySelector('#EcoPawsProductForm')?.addEventListener('submit', async event => { event.preventDefault(); const form = new FormData(event.currentTarget); await fetch('/cart/add.js', { method: 'POST', body: form }); openCart(); });
  }
});
